import React from "react";
import { Star } from "lucide-react";
import { tickerItems } from "../mock";

const Ticker = ({ bg = "bg-campaign-blue", text = "text-campaign-yellow" }) => {
  const row = [...tickerItems, ...tickerItems];
  return (
    <div className={`${bg} ${text} border-y-4 border-campaign-ink overflow-hidden py-3`}>
      <div className="marquee-track animate-marquee">
        {row.map((item, i) => (
          <span key={i} className="inline-flex items-center font-display text-lg sm:text-2xl uppercase mx-6">
            {item}
            <Star size={18} className="mx-6 fill-current" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
